export default {
  personal: 'Pessoa física',
  autonomous: 'Autônomo',
  mei: 'MEI',
  enterprise: 'Empresa',
  options: [
    { value: 'personal', text: 'Pessoa física' },
    { value: 'autonomous', text: 'Autônomo' },
    { value: 'mei', text: 'MEI' },
    { value: 'enterprise', text: 'Empresa' }
  ]
};
